module.exports = __webpack_public_path__ + "media/images/admin/icons/percent-31bf0cf98f4018d67faca7f990df2759.svg";